import { EmployeeSessionProvider } from '../shared/hooks/use-employee-session';

import { AppRoutes } from './app-routes';
import { GlobalStyle } from './global-style';
import { AppThemeProvider } from './providers/app-theme-provider';

export function App() {
  return (
    <AppThemeProvider>
      <EmployeeSessionProvider>
        <GlobalStyle />
        <AppRoutes />
      </EmployeeSessionProvider>
    </AppThemeProvider>
  );
}

export default App;
